import { Dispatch, SetStateAction, useContext, useState } from 'react';
import { MdDeleteForever } from 'react-icons/md';
import { Form } from 'react-bootstrap';
import { Appearance, Intent, Size } from '../../Components/designConstants';
import { IconButton } from '../../Components/IconButton';
import {
  HandleNewRowInput,
  CombinedCrossChannelKpis,
  HandleCrossChannelKpiNameEdit,
  KpiMappingsContext
} from './kpi-mapping-types';

interface OnBlurInputProps {
  value: string;
  disabled: boolean;
  onChange: (value: string) => void;
}

const OnBlurInput = ({ value, disabled, onChange }: OnBlurInputProps) => {
  const [localValue, setLocalValue] = useState(value);
  const [prevValue, setPrevValue] = useState(value);

  if (prevValue !== value) {
    setPrevValue(value);
    setLocalValue(value);
  }

  return (
    <Form.Control
      value={localValue}
      disabled={disabled}
      onChange={e => setLocalValue(e.target.value)}
      onBlur={() => {
        if (localValue !== value) {
          onChange(localValue);
        }
      }}
    />
  );
};

interface CrossChannelKpiColumnProps {
  crossChannelKpis: CombinedCrossChannelKpis;
  crossChannelKpiNameEdits: Record<string, string>;
  handleCrossChannelKpiNameEdit: (input: HandleCrossChannelKpiNameEdit) => void;
  handleNewRow: (input: HandleNewRowInput) => void;
  deleteNewRow: (id: string) => void;
  setCrossChannelKpisToDelete: Dispatch<SetStateAction<Record<string, number>>>;
}

const CrossChannelKpiColumn = ({
  crossChannelKpis,
  crossChannelKpiNameEdits,
  handleCrossChannelKpiNameEdit,
  handleNewRow,
  deleteNewRow,
  setCrossChannelKpisToDelete
}: CrossChannelKpiColumnProps) => {
  const { editMode } = useContext(KpiMappingsContext);

  return (
    <div className='cross-channel-kpi-column' data-testid='cross-channel-kpi-column'>
      <div className='column-header'>Cross-Channel KPI</div>
      <div className='kpi-label-spacer' />
      <div>
        {crossChannelKpis.map(({ crossChannelKpiLabel, crossChannelKpiId, isNewRow }) => (
          <div
            className='cross-channel-kpi-item'
            key={crossChannelKpiId}
            data-testid='cross-channel-kpi-item'
          >
            {editMode && (
              <IconButton
                appearance={Appearance.EMPTY}
                design={Intent.ERROR}
                size={Size.SM}
                onClick={() =>
                  isNewRow
                    ? deleteNewRow(crossChannelKpiId as string)
                    : setCrossChannelKpisToDelete(prev => ({
                        ...prev,
                        [crossChannelKpiId]: crossChannelKpiId as number
                      }))
                }
              >
                <MdDeleteForever style={{ color: 'red' }} />
              </IconButton>
            )}
            <OnBlurInput
              disabled={!editMode}
              value={crossChannelKpiNameEdits[crossChannelKpiId] || crossChannelKpiLabel}
              onChange={newVal =>
                isNewRow
                  ? handleNewRow({
                      crossChannelKpiId: String(crossChannelKpiId),
                      kpiLabel: newVal,
                      sourceLabel: '',
                      isCrossChannelKpiLabel: true
                    })
                  : handleCrossChannelKpiNameEdit({
                      id: crossChannelKpiId as number,
                      name: newVal
                    })
              }
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export { CrossChannelKpiColumn };
